import React from 'react';
import { getAgeKeyByValue, ageSliderDictionary } from '../../../utils/constants';
import Filter, { FilterModal, FilterSection } from './Filter';
import RangeFilter from './FilterComponents/CoreComponents/RangeFilter';

import styles from '../search.scss';

const EventAgeRangeFilter = (props) => {
    const { filters, filterInputs, handleFilterClick, filterModal, closeModals, handleFilterSubmit, ageDisplay, handleFilterUpdate, mobileOnly, desktopOnly, 'data-testid': dataTestId } = props;

    let { ageMin, ageMax } = filterInputs;
    ageMin = ageMin || 0;
    ageMax = ageMax || 71;
    const min = getAgeKeyByValue(ageMin) || 0;
    const max = getAgeKeyByValue(ageMax) || Object.keys(ageSliderDictionary).length - 1;

    const notActive = filters.ageMin === 7 && filters.ageMax === 71;
    const isActive = (filters && !notActive && (filters.ageMin || filters.ageMax)) || filterModal === 'age';

    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={'age'}
                handleFilterClick={handleFilterClick}
                isActive={isActive}
                onClick={() => {
                    handleFilterClick('age');
                }}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                data-testid={dataTestId}
            >
                Age{(filters && (filters.ageMin || filters.ageMax)) ? `: ${ageDisplay(min, max)}` : ''}
            </Filter>
            {filterModal === 'age' && (
                <FilterModal
                    title={'Age Range'}
                    onCloseClick={closeModals}
                    data-testid={dataTestId}
                    handleFilterSubmit={() => {
                        if (!filterInputs.ageMin && !filterInputs.ageMax) {
                            handleFilterUpdate({
                                ageMin: 1,
                                ageMax: 71,
                            });
                        }
                        handleFilterSubmit();
                    }}
                >
                    <FilterSection data-testid={dataTestId && `${dataTestId}.body`}>
                        <RangeFilter
                            title={`Age Range`}
                            rangeKeyMin={0}
                            rangeKeyMax={23}
                            customRangeDisplay={(minValue, maxValue) => ageDisplay(minValue, maxValue)}
                            defaultValueArr={[getAgeKeyByValue(ageMin), getAgeKeyByValue(ageMax)]}
                            min={min}
                            max={max}
                            onChange={(range) => {
                                handleFilterUpdate({
                                    ageMin: ageSliderDictionary[range[0]],
                                    ageMax: ageSliderDictionary[range[1]],
                                });
                            }}
                            data-testid={dataTestId && `${dataTestId}.range`}
                        />
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

export default EventAgeRangeFilter;
